import { SkillForm } from "@/core/skillForms/types";
import { summarizeDocumentSkillStep1 } from "./step1";

export const summarizeDocumentSkillForm: SkillForm = {
  skillId: "summary_document",
  title: "Resumir documento processual",
  steps: [summarizeDocumentSkillStep1],
};
